<template>
  <div class="container" :style="{width:width}" :class="{show:show}">
    <div class="handle-button" @click="visibleChange">
      <i :class="buttonIcon" style="font-weight:bold;"></i>
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: "300px"
    },
    defaultShow: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.show = this.defaultShow;
  },
  data() {
    return {
      buttonIcon: "el-icon-arrow-right",
      show: true
    };
  },
  methods: {
    visibleChange() {
      this.show = !this.show;
      this.changeIcon();
    },
    changeIcon() {
      if (this.buttonIcon == "el-icon-arrow-right") {
        this.buttonIcon = "el-icon-arrow-left";
      } else if (this.buttonIcon == "el-icon-arrow-left") {
        this.buttonIcon = "el-icon-arrow-right";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  position: absolute;
  right: 0px;
  top:0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
  transform: translate(100%);
 // background: rgba(255,255,255,0.85);
  z-index: 10;
  cursor: auto;
}
.handle-button {
  top: 50%;
  width: 20px;
  height: 32px;
  position: absolute;
  left: -20px;
  text-align: center;
  font-size: 19px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #00f9f8;;
  line-height: 32px;
  //   background: rgba(63, 72, 84, 0.8);
  background: rgba(79, 79, 79, 0.25);

  //box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.1);
}
// .handle-button:hover {
//   background: rgba(68, 136, 187, 0.8);
//   box-shadow: 1px 5px 15px #aaeeff;
// }
.content {
  width: 100%;
  height: 100%;
}
.show {
  transition: all 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  transform: translate(0);
}
</style>